import React from "react";
import Overlay from "@xo-union/tk-component-overlay";
import { useClasses } from "@xo-union/react-css-modules";
import { DialogContainer, ModalContainer, ModalPortal, DialogHeading, ScreenReaderOnly } from "@xo-union/ui-accessibility";
import cx from "classnames";
import styles from "../../css/styles.css";
import useIsModalBreakpoint from "../../useIsModalBreakpoint.js";
const ScreenReaderDescription = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreenReaderOnly, {
  as: DialogHeading,
  role: "heading",
  "aria-level": "1"
}, "Date picker."), /*#__PURE__*/React.createElement(ScreenReaderOnly, {
  as: "span"
}, "Date picker."));
const MobileOnlyModal = _ref => {
  let {
    id,
    isOpen,
    children,
    onClose,
    initialFocusRef
  } = _ref;
  const isModal = useIsModalBreakpoint();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalPortal, null, /*#__PURE__*/React.createElement(Overlay, {
    enabled: isModal && isOpen,
    animation: false
  }, /*#__PURE__*/React.createElement(ModalContainer, {
    id: isModal ? id : undefined,
    enabled: isModal && isOpen,
    onClose: onClose,
    initialFocusRef: initialFocusRef
  }, isModal && /*#__PURE__*/React.createElement(ScreenReaderDescription, null), isModal ? children(true) : null))), /*#__PURE__*/React.createElement(React.Fragment, null, isModal ? null : children(false)));
};
const DropdownContainer = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    id,
    isOpen = true,
    classes: classesProp,
    numberOfMonths = 1,
    children,
    onClose,
    onBlur,
    initialFocusRef
  } = _ref2;
  const classes = useClasses(styles, classesProp);
  const style = {
    '--tkww-union-datepicker-number-of-months': numberOfMonths
  };
  return /*#__PURE__*/React.createElement(MobileOnlyModal, {
    id: id,
    initialFocusRef: initialFocusRef,
    onClose: onClose,
    isOpen: isOpen
  }, isModal => /*#__PURE__*/React.createElement(DialogContainer, {
    id: isModal ? undefined : id,
    initialFocusRef: initialFocusRef,
    onClose: onClose,
    enabled: isOpen && !isModal,
    ref: ref,
    style: style,
    onBlur: onBlur,
    className: cx(classes['relative-container'], isOpen ? classes['is-open'] : classes['is-closed']),
    "aria-hidden": isOpen ? undefined : 'true'
  }, /*#__PURE__*/React.createElement("div", {
    className: classes['dropdown-container']
  }, !isModal && /*#__PURE__*/React.createElement(ScreenReaderDescription, null), children)));
});
export default DropdownContainer;